import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { TableBody } from './common/TableBody/TableBody'
import { TableCell } from './common/TableCell/TableCell'
import { TableHead } from './common/TableHead/TableHead'
import { TableRow } from './common/TableRow/TableRow'

import styles from './Table.module.scss'

type TableProps = {
  children?: React.ReactNode
  className?: string
}

type TableComponent = ((props: TableProps) => React.JSX.Element) & {
  Body: typeof TableBody
  Cell: typeof TableCell
  Head: typeof TableHead
  Row: typeof TableRow
}

export const Table: TableComponent = Object.assign(
  ({ children, className }: TableProps) => (
    <Box className={styles.container}>
      <table className={cx(styles.table, className)}>{children}</table>
    </Box>
  ),
  {
    Body: TableBody,
    Cell: TableCell,
    Head: TableHead,
    Row: TableRow,
  },
)
